import {getOfferTemplateQueryOptions} from "@project/application/sales/offer-templates";
import {AppErrorBoundary} from "@project/layouts";
import {createFileRoute} from "@tanstack/react-router";
import {offerTemplateItemMessages as messages} from "../-messages/offer-template-item.messages";
import {OfferTemplatePage} from "./-page/offer-template.page";
import {OfferTemplatePending} from "./-page/offer-template.pending";

export const Route = createFileRoute("/_app/sales/offers/templates/$offerTemplateId")({
  component: RouteComponent,
  loader: ({context: {queryClient}, params}) =>
    queryClient.ensureQueryData(getOfferTemplateQueryOptions(params.offerTemplateId)),
  errorComponent: AppErrorBoundary,
  pendingComponent: OfferTemplatePending,
  staticData: {
    meta: {
      getLabel: (params: Record<string, string>, data?: unknown) =>
        data &&
        typeof data === "object" &&
        "offerTemplateId" in data &&
        typeof data.offerTemplateId === "string" &&
        data.offerTemplateId.toLowerCase() === params.offerTemplateId?.toLowerCase() &&
        "name" in data &&
        typeof data.name === "string"
          ? data.name
          : undefined,
      getLabelDescriptor: (params: Record<string, string>) => ({
        id: messages.byId.id,
        values: {offerTemplateId: params.offerTemplateId},
      }),
    },
  },
});
function RouteComponent() {
  const {offerTemplateId} = Route.useParams();
  return <OfferTemplatePage offerTemplateId={offerTemplateId} />;
}
